import { RetrievalAsset } from 'pages/Retrieval/RetrievalService/types';
import { IAddAssetFormValues } from './types';
import { ErrorMessages, AssetStatusSelfDescriptive } from 'global-constants';
import { Asset } from 'types';

const deriveAssetName = (addAssetFormValues: IAddAssetFormValues): string => {
  const { make, model, assetType } = addAssetFormValues;
  const displayMake = make ? `${make} ` : '';
  const displayModel = model ? `${model} ` : '';

  return `${displayMake}${displayModel}${assetType}`.trim();
};

export const makeRetrievalAddAsset = (
  addAssetFormValues: IAddAssetFormValues,
  id: string,
  addedAsset: boolean = true
): RetrievalAsset => {
  const { assetType, ...restOfAssetForm } = addAssetFormValues;
  return {
    id,
    addedAsset,
    type: assetType,
    name: deriveAssetName(addAssetFormValues),
    optionAnswers: [],
    ...restOfAssetForm,
  };
};

export const isSerialNumberInLocalStoredAssets = (
  serialNumber: string,
  localStoredAssets: RetrievalAsset[]
): boolean => {
  return localStoredAssets.some((asset) => asset.serialNumber === serialNumber);
};

export const handleAssetCreateOrAssignOrError = (
  data: any,
  handleAssetSubmit: Function,
  setError: Function,
  serialNumber: string,
  formData: IAddAssetFormValues
) => {
  const assets = data?.searchAssets?.assets || [];
  const existingAsset = assets.find(
    (asset: Asset) => asset.serialNumber === serialNumber
  );
  const isNewAsset = !existingAsset || assets.length === 0;

  const isExistingAssetAssigned = !!existingAsset?.assignee?.id;
  const isExistingAssetUnassigned = !isExistingAssetAssigned;
  const isAllocated =
    existingAsset?.status === AssetStatusSelfDescriptive.MONO_ALLOCATED;
  const isTransfered =
    existingAsset?.status === AssetStatusSelfDescriptive.MONO_TRANSFERRED;

  const isAssignableAsset =
    isExistingAssetUnassigned && (isAllocated || isTransfered);

  const isNotAssignableAsset = !isAssignableAsset;

  if (isNewAsset) {
    handleAssetSubmit(formData);
  } else if (isExistingAssetAssigned || isNotAssignableAsset) {
    setError('serialNumber', {
      type: 'custom',
      message: ErrorMessages.SERIAL_NUMBER_ALREADY_EXISTS,
    });
  } else if (isAssignableAsset) {
    handleAssetSubmit(formData, true, existingAsset);
  } else {
    handleAssetSubmit(formData);
  }
};
